import { useAuth } from "@/lib/auth";
import { useState } from "react";
import { Navigate } from "react-router-dom";

export function Login() {
  const { signIn, user, loading } = useAuth();
  const [err, setErr] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  // Once Firebase confirms a signed-in user (either from persisted session on
  // page load, or because signInWithPopup just resolved), bounce to the
  // arena. Without this, Login sat on the form after the popup closed and
  // the voter had to close/reopen the tab to reach the app.
  if (!loading && user) {
    return <Navigate to="/search" replace />;
  }

  async function handleSignIn() {
    setPending(true);
    setErr(null);
    try {
      await signIn();
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-sm space-y-6 rounded-lg border bg-card p-8 shadow-sm">
        <div className="space-y-1 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">Ranking Arena</h1>
          <p className="text-sm text-muted-foreground">Sign in with your work Google account.</p>
        </div>
        <button
          type="button"
          onClick={handleSignIn}
          disabled={pending}
          className="flex w-full items-center justify-center gap-2 rounded-md border bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm transition hover:bg-primary/90 disabled:opacity-50"
        >
          {pending ? "Signing in…" : "Sign in with Google"}
        </button>
        {err ? <p className="text-sm text-destructive">{err}</p> : null}
      </div>
    </div>
  );
}
